<script setup>
import { computed, ref, watch } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { useCrmEmbedTheme } from 'dashboard/composables/useCrmEmbedTheme';
import { useRoute } from 'vue-router';

const { accountId } = useAccount();
const route = useRoute();
const frameLoaded = ref(false);
const frameError = ref(false);

const { theme } = useCrmEmbedTheme();

const crmUrl = computed(() => {
  const params = new URLSearchParams({
    accountId: String(accountId.value),
    theme: theme.value,
    view: route.meta.crmView || 'kanban',
  });
  return `/crm/?${params.toString()}`;
});

const reloadFrame = () => {
  frameLoaded.value = false;
  frameError.value = false;
  const iframe = document.querySelector('#crm-kanban-frame');
  if (iframe) iframe.src = crmUrl.value;
};

watch(crmUrl, () => {
  frameLoaded.value = false;
  frameError.value = false;
});
</script>

<template>
  <section class="flex flex-col flex-1 min-w-0 min-h-0 bg-n-surface-1">
    <div class="relative flex-1 min-h-0">
      <div
        v-if="!frameLoaded && !frameError"
        class="absolute inset-0 z-10 grid place-items-center bg-n-surface-1 text-n-slate-11"
      >
        <span class="crm-frame-spinner" aria-label="Carregando" />
      </div>
      <div
        v-if="frameError"
        class="absolute inset-0 z-20 grid place-items-center p-6 bg-n-surface-1"
      >
        <div class="max-w-md text-center">
          <h2 class="m-0 text-lg font-semibold text-n-slate-12">
            Nao foi possivel carregar o CRM
          </h2>
         
          <button
            type="button"
            class="inline-flex items-center h-9 px-3 text-sm font-medium rounded-lg text-white bg-n-brand hover:bg-n-brand/90"
            @click="reloadFrame"
          >
            Tentar novamente
          </button>
        </div>
      </div>
      <iframe
        id="crm-kanban-frame"
        :src="crmUrl"
        title="CRM Kanban"
        class="block w-full h-full border-0 bg-n-surface-1"
        @load="frameLoaded = true"
        @error="frameError = true"
      />
    </div>
  </section>
</template>

<style scoped>
.crm-frame-spinner {
  width: 28px;
  height: 28px;
  border: 3px solid rgba(59, 130, 246, 0.18);
  border-top-color: rgb(59, 130, 246);
  border-radius: 9999px;
  animation: crm-frame-spin 0.75s linear infinite;
}

@keyframes crm-frame-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
